import { toast } from 'react-hot-toast';

export const uploadFileFromPresignedUrl = async (url, file) => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: {
        'x-amz-acl': 'public-read',
        'Content-Type': file.type
      }
    });

    if (!response.ok) {
      throw new Error('Erro ao enviar o arquivo.');
    }

    return url.split('?')[0];
  } catch (error) {
    toast.error('Erro ao enviar imagem da redação.');
    console.error(error);
    throw error;
  }
};
